import { Link } from "react-router-dom";
import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledTitle = styled(Typography)(({ theme: { typography } }) => ({
  fontWeight: typography.fontWeightBold,
}));

export const StyledText = styled(Typography)(({ theme: { palette } }) => ({
  color: palette.grey["700"],
}));

export const StyledLink = styled(Link)(({ theme: { palette, typography } }) => ({
  color: palette.grey["700"],
  fontSize: typography.pxToRem(15),
  textDecoration: "none",

  "&:hover": {
    textDecoration: "underline",
  },
}));
